module.exports = __webpack_public_path__ + "static/media/NZFCD_search_header_stacked.9e8453bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NZFCD_search_header_stacked.png
// module id = 844
// module chunks = 0